import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=5086248e&"
import script from "./uploadfile.vue?vue&type=script&lang=js&"
export * from "./uploadfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5086248e')) {
      api.createRecord('5086248e', component.options)
    } else {
      api.reload('5086248e', component.options)
    }
    module.hot.accept("./uploadfile.vue?vue&type=template&id=5086248e&", function () {
      api.rerender('5086248e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/forum/components/uploadfile.vue"
export default component.exports